import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useValidatePassword } from '@/SignUp/hooks/useValidatePassword';
import apiToken, { handleApiError } from '@/shared/services/axiosInstance';
import Modal from '@/shared/components/UI/Modal';
import Button from '@/shared/components/UI/Button';
import Input from '@/shared/components/UI/Input';

interface ChangePasswordModalProps {
  setIsChangePassword: React.Dispatch<React.SetStateAction<boolean>>;
}

const ChangePasswordModal = ({
  setIsChangePassword,
}: ChangePasswordModalProps) => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const {
    validatePassword,
    validateConfirmPassword,
    passwordError,
    confirmPasswordError,
  } = useValidatePassword();

  const saveChangePassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!passwordError && !confirmPasswordError) {
      try {
        await apiToken.patch('/api/v1/user/password', { password });

        setIsChangePassword(false);
        alert('Password has been changed successfully. Please log in again.');
        sessionStorage.clear();
        navigate('/login');
      } catch (error) {
        const errorMessage = handleApiError(error);
        console.error('Failed to change password:', errorMessage);
        alert(errorMessage);
      }
    }
  };

  return (
    <Modal isOpen onClose={() => setIsChangePassword(false)} size="md">
      <div className="text-left">
        <p className="mb-4 text-[18px] font-bold text-[#1d1d1d]">
          Change Password
        </p>
        <form method="post" onSubmit={saveChangePassword}>
          <div className="mb-5">
            <Input
              type="password"
              name="password"
              placeholder={`letter, number, characters (excluding \\ ' " | ~ \`) 8-40`}
              label="Password"
              labelClassName="sr-only"
              onChange={(e) => {
                validatePassword(e.target.value);
                setPassword(e.target.value);
              }}
              error={passwordError}
              className="h-9"
              fullWidth
            />
          </div>
          <div className="mb-3">
            <Input
              type="password"
              name="confirm-password"
              placeholder="Confirm Password"
              label="Confirm Password"
              labelClassName="sr-only"
              onChange={(e) => {
                validateConfirmPassword(password, e.target.value);
              }}
              error={confirmPasswordError}
              className="h-9"
              fullWidth
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button
              type="submit"
              variant="primary"
              size="md"
              className="px-4 py-3"
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ChangePasswordModal;
